var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (fieldsetCounter, globals, id, validationId) {
      pug_mixins["input"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.type) {
attributes.type = 'text'
}
if (!attributes.attributes) {
attributes.attributes = {}
}
if (!attributes.groupAttributes) {
attributes.groupAttributes = {}
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": pug.classes(["form-group",attributes.groupHtmlClass], [false,false])},attributes.groupAttributes]), true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("class", pug.classes(["control-label",attributes.labelHtmlClass], [false,true]), false, true)+pug.attr("for", id, true, true)) + "\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Flabel\u003E";
}
if (attributes.divTitle) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["control-label",attributes.divTitleHtmlClass], [false,true]), false, true)) + "\u003E" + (null == (pug_interp = attributes.divTitle) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes(["form-control",attributes.fieldHtmlClass], [false,true]),"id": pug.escape(id),"type": pug.escape(attributes.type),"placeholder": pug.escape(attributes.placeholder),"ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"name": pug.escape(id),"value": pug.escape(attributes.value),"required": pug.escape(attributes.required),"ng-pattern": pug.escape(attributes['ng-pattern']),"disabled": pug.escape(attributes.disabled),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E";
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (attributes.validationMessages) {
validationId = '"'+ id +'"'
if (attributes.validationId) {
validationId = attributes.validationId
}
pug_mixins["validationMessages"].call({
attributes: {"key": pug.escape(validationId),"validationMessages": pug.escape(attributes.validationMessages)}
});
}
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};



















































































































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};





























































pug_mixins["form"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.name) {
globals.formname = attributes.name
}
pug_html = pug_html + "\u003Cform" + (pug.attrs(pug.merge([{"novalidate": pug.escape(true)},attributes]), true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fform\u003E";
};
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}





















pug_html = pug_html + "\u003Cdiv class=\"row\" ng-if=\"activation.isActivationCodeValid.error === undefined || activation.isActivationCodeValid.error === true\"\u003E\u003Cdiv class=\"columns medium-10 medium-centered\"\u003E\u003Cdiv class=\"activationWrapper\"\u003E\u003Choneypot-form\u003E\u003Cdiv class=\"row\"\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cspan\u003ESie haben von uns einen persönlichen Aktivierungscode erhalten? Dann können Sie sich hier auf unserem System freischalten.\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cbr\u003E\u003Cdiv class=\"code\"\u003E\u003Clabel class=\"code-label\" for=\"activation.enteredCodePart1\"\u003EPersönlicher Aktivierungscode\u003C\u002Flabel\u003E\u003Cdiv class=\"code-fields\"\u003E\u003Cdiv class=\"code-field\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "activation.enteredCodePart1","type": "text","required": pug.escape(true),"data-cy": "vn.registration.activation.customerAssignment.inputActivationCode","attributes": {"ng-maxlength":"5","ng-change":"activation.onEnterCode()","ng-pattern":"\u002F^[A-Za-z0-9]*$\u002F","vn-auto-switch-fields":"true","tabindex":1}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cspan class=\"code-separator\"\u003E-\u003C\u002Fspan\u003E\u003Cdiv class=\"code-field\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "activation.enteredCodePart2","type": "text","required": pug.escape(true),"data-cy": "vn.registration.activation.customerAssignment.inputActivationCode","attributes": {"ng-maxlength":"5","ng-change":"activation.onEnterCode()","ng-pattern":"\u002F^[A-Za-z0-9]*$\u002F","vn-auto-switch-fields":"true","tabindex":2}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cspan class=\"code-separator\"\u003E-\u003C\u002Fspan\u003E\u003Cdiv class=\"code-field code-field-small\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "activation.enteredCodeChecksum","type": "text","required": pug.escape(true),"data-cy": "vn.registration.activation.customerAssignment.inputActivationCode","attributes": {"ng-maxlength":"1","ng-change":"activation.onEnterCode()","ng-pattern":"\u002F^[A-Za-z0-9]*$\u002F","tabindex":3}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"activationCodeForm.$error\"\u003E\u003Cdiv class=\"helpText\" ng-message=\"pattern\"\u003EIhr Code konnte nicht aktiviert werden. Bitte prüfen Sie Ihre Eingabe. Sollte eine Aktivierung wiederholt nicht möglich sein, so wenden Sie sich bitte an support@valuenet.de\u003C\u002Fdiv\u003E\u003Cdiv class=\"helpText\" ng-message=\"maxlength\"\u003EBitte überprüfen Sie Ihre Eingabe.\u003C\u002Fdiv\u003E\u003Cdiv class=\"helpText\" ng-message=\"required\"\u003EBitte geben Sie Ihren Persönlicher Aktivierungscode ein.\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"helpText\" ng-if=\"activation.errorCode\"\u003EBitte überprüfen Sie Ihre Eingabe\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"class": "form-padding columns medium-12","name": "activation.forms.activationCodeForm"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fhoneypot-form\u003E\u003Cdiv class=\"row\" ng-if=\"!activation.employee\"\u003E\u003Cbutton class=\"button button-primary right\" ng-disabled=\"!canContinue()\" ng-click=\"activation.getPattern()\" data-cy=\"vn.registration.activation.customerAssignment.buttonSubmitActivationCode\"\u003EWeiter\u003C\u002Fbutton\u003E\u003Ca class=\"button button-primary left\" data-cy=\"vn.registration.activation.customerAssignment.buttonCancel\" href=\"\u002Fcidaas_login\"\u003EAbbrechen\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"activation.employee\"\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cspan\u003EBitte tragen Sie hier die Ihre Personalnummer ein, welche auf Ihrer Entgeltabrechnung verzeichnet ist. Bitte geben Sie diese exakt so ein.\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cbr\u003E";
pug_mixins["input"].call({
attributes: {"key": "activation.personalNumber","id": "personalNumber","divTitle": "Personalnummer","type": "text","required": pug.escape(true),"data-cy": "vn.registration.activation.customerAssignment.inputPersonalNumber","validationMessages": {"required":"{{'Bitte geben Sie Ihre Personalnummer im Format ' + (pattern && pattern.is_enabled ? pattern.human_syntax : '') + ' ein'}}","pattern":"{{pattern.description && 'Bitte geben Sie Ihre Personalnummer im Format ' + pattern.human_syntax + ' ein'}}","wrong":"{{'Bitte geben Sie Ihre Personalnummer im Format ' + pattern.human_syntax + ' ein'}}"},"attributes": {"ng-pattern":"pattern && pattern.is_enabled ? pattern.syntax : null","ng-change":"activation.handlePersonalNumberChange()","ng-model-options":"{ debounce: 100 }","tabindex":4}}
});
pug_html = pug_html + "\u003Cbutton class=\"button button-primary right\" ng-click=\"activation.validatePersonalNumber()\" style=\"margin-top: 15px; background-color: {{ activation.isValidationResult.isValid ? &quot;green&quot; : &quot;#003b55&quot; }}\"\u003E{{ activation.isValidationResult.isValid ? 'Validiert' : 'Validieren' }}\u003C\u002Fbutton\u003E";
},
attributes: {"class": "form-padding columns small-12","name": "activation.forms.activationPersonalForm"}
});
pug_html = pug_html + "\u003Cdiv class=\"columns small-12\"\u003E\u003Cspan class=\"error\" ng-if=\"activation.isValidationResult.error\"\u003E{{ activation.isValidationResult.message }}\u003C\u002Fspan\u003E\u003Cbutton class=\"button button-primary right\" ng-disabled=\"!activation.canPassPersonalnumber()\" ng-click=\"activation.validateActivationCredentials()\" data-cy=\"vn.registration.activation.customerAssignment.buttonSubmitPersonalNumber\"\u003EWeiter\u003C\u002Fbutton\u003E\u003Ca class=\"button button-primary left\" href=\"\u002Fcidaas_login\" data-cy=\"vn.registration.activation.customerAssignment.buttonCancel\"\u003EAbbrechen\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"activation.isActivationCodeValid.error === false &amp;&amp; activation.isActivationCodeValid.error !== undefined &amp;&amp; !activation.errorCode\"\u003E\u003Cdiv class=\"columns medium-10 medium-centered\"\u003E\u003Cdiv class=\"activationWrapper\"\u003E\u003C!-- NEW WAY--\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv ng-hide=\"activation.success\"\u003E\u003Ch1 class=\"mainform\"\u003E\u003C\u002Fh1\u003E\u003Cspan\u003EVielen Dank. Wir konnten Ihren Code zuordnen, {{ employee.anrede ? employee.anrede : 'Herr\u002F Frau' }} {{ employee.lastname ? employee.lastname : 'XXXXXX' }}. Bitte ergänzen Sie noch Ihre E-Mail Adresse, damit wir den Zugang für Sie freischalten können. Sie erhalten von uns eine Emailbestätigung mit einem Einmalpasswort.\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cbr\u003E\u003Cbr\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-6\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "activation.firstname","title": "Vorname","type": "text","data-cy": "vn.registration.activation.employeeData.inputFirstname","validationMessages": {"required":"Geben Sie einen Vornamen an"},"attributes": {"ng-change":"activation.handleNameChange('firstname')"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-6\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "activation.lastname","title": "Nachname","type": "text","data-cy": "vn.registration.activation.employeeData.inputLastname","validationMessages": {"required":"Geben Sie einen Nachnamen an"},"attributes": {"ng-change":"activation.handleNameChange('lastname')"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-12\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "activation.email","title": "E-Mail Adresse Privat","type": "email","data-cy": "vn.registration.activation.employeeData.inputEmail","required": pug.escape(true),"validationMessages": {"email":"Bitte geben Sie eine gültige E-Mail Adresse an","required":"Geben Sie Ihren E-Mail Adresse an","unique":"Diese E-Mail-Adresse wird bereits verwendet","domain":"{{activation.getDomainErrorMessage()}}","exist":"Validierung der E-Mail-Adresse ist fehlgeschlagen"},"attributes": {"ng-change":"activation.handleEmailInputChange()","ng-model-options":"{ debounce: 300 }"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-12\"\u003E\u003Cdiv class=\"form-group\" ng-click=\"activation.toggleRead($event)\"\u003E\u003Cdiv class=\"checkbox\"\u003E\u003Cinput type=\"checkbox\" ng-model=\"activation.toc\" id=\"activationdatatoc\" tabindex=\"6\" required data-cy=\"vn.registration.activation.employeeData.checkToc\"\u003E\u003Clabel for=\"activationdatatoc\"\u003E\u003Cspan class=\"reg-text\"\u003EIch habe die&nbsp;\u003Cspan class=\"blue\" style=\"font-weight:bold; text-decoration:underline;\"\u003EDatenschutzerklärung\u003C\u002Fspan\u003E&nbsp;zur Kenntnis genommen und bestätige dies mit dem Absenden der Nachricht. Ich stimme zu, dass meine Angaben und Daten zur Beantwortung meiner Anfrage elektronisch erhoben und gespeichert werden. Die Einwilligung kann ich jederzeit für die Zukunft widerrufen.\u003Cbr\u003E\u003Cbr\u003E(Öffnen Sie die Datenschutzerklärung über den Link, nach dem Lesen können Sie ganz unten bestätigen)\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cspan class=\"error\" ng-show=\"activation.error\"\u003EIhre Eingaben konnten nicht gespeichert werden.\u003C\u002Fspan\u003E\u003Cbutton class=\"button button-primary right\" type=\"submit\" ng-disabled=\"!activation.forms.activationForm.$valid\" data-cy=\"vn.registration.activation.employeeData.buttonSubmit\"\u003EBeantragen\u003C\u002Fbutton\u003E\u003Ca class=\"button button-primary left\" href=\"\u002Fcidaas_login\" data-cy=\"vn.registration.activation.employeeData.buttonCancel\"\u003EAbbrechen\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C!--.clearfix--\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-show=\"activation.success\"\u003E\u003Cp\u003EVielen Dank. Wir konnten Ihren Code zuordnen.\u003Cbr\u003EBitte prüfen Sie die angegebenen Daten, korrigieren bzw. ergänzen die Informationen.\u003Cbr\u003ENach Abschluss erhalten Sie von uns eine Bestätigung via E-Mail mit einem Einmalpasswort.\u003C\u002Fp\u003E\u003Ca href=\"\u002F\"\u003EZurück\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"class": "form-padding","name": "activation.forms.activationForm","ng-submit": "activation.handleUserActivation()"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined, "validationId" in locals_for_with ?
        locals_for_with.validationId :
        typeof validationId !== 'undefined' ? validationId : undefined));
    ;;return pug_html;};
module.exports = template;